module.exports = __webpack_public_path__ + "static/media/1021409.863c20b8.jpg";